import React, { useMemo } from "react";
import styled from "styled-components";
import type { CommonGroupItem } from "src/types/common/commonCodeTypes";

type Props = {
  groups: CommonGroupItem[];
  selectedGrpCode: string;

  grpCode: string;
  grpName: string;
  useYn: "" | "true" | "false";
  size: number;

  onChangeGroupQuery: (
    patch: Partial<{ grpCode: string; grpName: string; useYn: boolean | undefined; size: number }>
  ) => void;
  onSearchGroups: () => void;
  onResetGroups: () => void;

  onSelectGroup: (grpCode: string) => void;
  onSearchCodes: () => void;

  onCreateGroup: () => void;

  /** ✅ 추가: 그룹 수정 */
  onEditGroup?: (item: CommonGroupItem) => void;
};

export default function CommonCodeGroupBar({
  groups,
  selectedGrpCode,
  grpCode,
  grpName,
  useYn,
  size,
  onChangeGroupQuery,
  onSearchGroups,
  onResetGroups,
  onSelectGroup,
  onSearchCodes,
  onCreateGroup,
  onEditGroup,
}: Props) {
  const selectedGroup = useMemo(
    () => groups.find((g) => g.grpCode === selectedGrpCode) || null,
    [groups, selectedGrpCode]
  );

  return (
    <Wrap>
      <Row>
        <Label>그룹 선택</Label>
        <Select value={selectedGrpCode || ""} onChange={(e) => onSelectGroup(e.target.value)}>
          <option value="" disabled>
            그룹을 선택하세요
          </option>
          {groups.map((g) => (
            <option key={g.grpCode} value={g.grpCode}>
              {g.grpCode} - {g.grpName}
            </option>
          ))}
        </Select>

        <SmallBtn type="button" onClick={onSearchCodes} disabled={!selectedGrpCode}>
          코드 검색
        </SmallBtn>

        <SmallBtn type="button" onClick={onCreateGroup}>
          + 그룹 생성
        </SmallBtn>

        <SmallBtn
          type="button"
          disabled={!selectedGroup || !onEditGroup}
          onClick={() => {
            if (!selectedGroup) return;
            onEditGroup?.(selectedGroup);
          }}
        >
          그룹 수정
        </SmallBtn>
      </Row>

      <Row>
        <Input
          value={grpCode}
          onChange={(e) => onChangeGroupQuery({ grpCode: e.target.value })}
          placeholder="grpCode"
        />
        <Input
          value={grpName}
          onChange={(e) => onChangeGroupQuery({ grpName: e.target.value })}
          placeholder="grpName"
        />
        <Select
          value={useYn}
          onChange={(e) =>
            onChangeGroupQuery({
              useYn: e.target.value === "" ? undefined : e.target.value === "true",
            })
          }
        >
          <option value="">사용여부 전체</option>
          <option value="true">사용</option>
          <option value="false">미사용</option>
        </Select>

        <Select
          value={String(size)}
          onChange={(e) => onChangeGroupQuery({ size: Number(e.target.value) })}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </Select>

        <SmallBtn type="button" onClick={onSearchGroups}>
          그룹 검색
        </SmallBtn>
        <SmallBtn type="button" onClick={onResetGroups}>
          초기화
        </SmallBtn>
      </Row>
    </Wrap>
  );
}

/** ===== styles (간단) ===== */
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const Label = styled.div`
  font-size: 12px;
  color: #666;
`;

const Input = styled.input`
  height: 36px;
  padding: 0 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
`;

const Select = styled.select`
  height: 36px;
  padding: 0 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background: #fff;
`;

const SmallBtn = styled.button`
  height: 36px;
  padding: 0 12px;
  border-radius: 10px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
